import { Dialog as MuiDialog } from '@mui/material'

import { DialogProvider } from './dialog-context'

const sizeMap = {
  small: 440,
  medium: 600,
  large: 800,
  'extra-large': 1000,
  'full-inset': 'calc(100% - 32px)',
  full: '100%',
} as const

interface Props {
  open: boolean
  size?: 'small' | 'medium' | 'large' | 'extra-large' | 'full-inset' | 'full'
  // Overrides the size preset's width when a specific px/value is needed (e.g. a design-spec'd 1200px dialog).
  width?: number | string
  zIndex?: number
  children: React.ReactNode
  onClose: VoidFunction
}

export function DialogRoot({ open, size = 'small', width, zIndex, children, onClose }: Props) {
  const height = size === 'full-inset' ? 'calc(100% - 32px)' : undefined
  return (
    <DialogProvider onClose={onClose}>
      <MuiDialog
        open={open}
        fullScreen={size === 'full'}
        sx={zIndex === undefined ? undefined : { zIndex }}
        PaperProps={{ sx: { width: width ?? sizeMap[size], maxWidth: '100%', height } }}
      >
        {children}
      </MuiDialog>
    </DialogProvider>
  )
}
